import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import MobileStepper from '@material-ui/core/MobileStepper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { EVENT_ID, getUserID, USER_API_URL } from '../../constants';
import Tooltip from '@mui/material/Tooltip';
import swal from 'sweetalert';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  header: {
    fontSize: '1.2rem',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

class QuizDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      qCount: 0,
      open: this.props.open,
      quizIdx: this.props.quizIdx,
      quizData: this.props.data,
      confirmOpen: false,
      confirmSubmit: false,
      matches: window.matchMedia('(max-width:1280px)').matches,
    };
    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.quizSubmit = this.quizSubmit.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    // console.log(this.props.data);
    // console.log('quizIdx', this.props.quizIdx);
    // const pgmId = sessionStorage.getItem('_in_session');
    const sessionData = this.props.data.filter((post) => {
      return post.sessionNo === this.props.quizIdx;
    });
    // eslint-disable-next-line
    this.props.data.map((d) => {
      this.setState({ [d.id]: '' });
    });
    // console.log(sessionData.length);

    sessionData.sort((a, b) => {
      return Number(a.orderNo) - Number(b.orderNo);
    });

    this.setState({ quizData: sessionData, qCount: sessionData.length });
  }

  onOpen() {
    this.setState({ open: true });
  }

  onClose(_isSubmit) {
    this.setState({ confirmOpen: true, confirmSubmit: false });
    // if (this.state.quizAnswer && Object.keys(this.state.quizAnswer).length === this.state.qCount) {
    //   console.log(this.state.quizAnswer);
    //
    //   // this.props.onClose();
    // } else {
    //   // alert('문제 다안풀었어');
    //   this.setState({ confirmOpen: true });
    // }
  }
  onSubmit() {
    this.setState({ confirmSubmit: true, confirmOpen: true });
  }

  quizSubmit() {
    const keys = Object.keys(this.state.quizAnswer);
    let arrAnswer = [];
    for (let k of keys) {
      arrAnswer.push({ pollId: k, val: this.state.quizAnswer[k] });
    }

    fetch(`${USER_API_URL}/user/quiz`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: `username=${encodeURIComponent(sessionStorage.getItem('_in_name'))}&userid=${getUserID()}&evt=${EVENT_ID}&sessionNo=${
        Number(this.props.quizCnt) + 1
      }&quizAnswer=${JSON.stringify(arrAnswer)}`,
    })
      .then((res) => {
        //console.log(res);
        swal('', 'submitted', 'success');
        // alert('제출되었습니다.');
        this.props.onClose(this.props.quizIdx, arrAnswer);
      })
      .catch((err) => {
        console.log(err);
        // alert('정상적으로 등록되지 않았습니다. 다시 시도해주세요.');
        swal('error', 'please try again', 'error');
      });
  }

  handleNext() {
    if (this.state.activeStep < this.state.qCount - 1) {
      this.setState({ activeStep: this.state.activeStep + 1 });
    }
  }
  handlePrev() {
    if (this.state.activeStep > 0) {
      this.setState({ activeStep: this.state.activeStep - 1 });
    }
  }
  handleClose(_val) {
    if (_val === 'Y') {
      this.setState({ confirmOpen: false, open: false });
      if (this.state.confirmSubmit) {
        this.quizSubmit();
      } else {
        this.props.onClose();
      }
    } else if (_val === 'N') {
      this.setState({ confirmOpen: false });
    } else if (_val === 'R') {
    }
  }

  changeAnswer(e, quiz) {
    let arr = {};
    if (this.state.quizAnswer) {
      arr = this.state.quizAnswer;
    }
    arr[quiz.id] = quiz.a.indexOf(e.target.value);

    console.log(e.target.value);
    this.setState({ quizAnswer: arr, [quiz.id]: e.target.value });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          onClose={this.onClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.onClose}>
            {this.state.qCount ? (
              <Grid container>
                <Typography style={{ fontSize: 'large', fontWeight: 'bold', color: this.props.theme.palette.primary.main }}>
                  [ 분과전문의 문제풀이 ]
                </Typography>
                &nbsp;&nbsp;
                <Typography style={{ fontSize: 'large' }}>
                  {this.state.quizData[this.state.activeStep].orderNo}&nbsp;&nbsp;/&nbsp;&nbsp;{this.state.qCount}
                </Typography>
              </Grid>
            ) : (
              ''
            )}

            {/* {this.state.qCount ? `Quiz (Total: ${this.state.qCount} )` : ''} */}
          </DialogTitle>
          <DialogContent dividers>
            <div className={classes.root}>
              <Paper square elevation={0} className={classes.header}>
                <div className={classes.header} dangerouslySetInnerHTML={{ __html: this.state.quizData[this.state.activeStep].q }}></div>
                {this.state.quizData[this.state.activeStep].quizImg && (
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <img src={`${this.state.quizData[this.state.activeStep].quizImg}`} alt="" style={{ maxWidth: '100%' }} />
                  </div>
                )}
                {this.state.quizData[this.state.activeStep].quizImg2 && (
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <img src={`${this.state.quizData[this.state.activeStep].quizImg2}`} alt="" style={{ maxWidth: '100%' }} />
                  </div>
                )}
                <RadioGroup
                  value={this.state[this.state.quizData[this.state.activeStep].id]}
                  onChange={(e) => {
                    this.changeAnswer(e, this.state.quizData[this.state.activeStep], this.state.activeStep);
                  }}
                >
                  {this.state.quizData[this.state.activeStep].a.map((aItem, idx) => {
                    return (
                      <div key={idx}>
                        {aItem.indexOf('img') !== -1 ? (
                          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                            <FormControlLabel value={aItem} control={<Radio />} label={''} key={idx} />
                            <div
                              className={classes.header}
                              dangerouslySetInnerHTML={{ __html: this.state.quizData[this.state.activeStep].a[idx] }}
                            />
                          </Grid>
                        ) : aItem.indexOf('<sup>') !== -1 ? (
                          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                            <FormControlLabel value={aItem} control={<Radio />} label={''} key={idx} />
                            <span
                              style={{ fontSize: '1rem', marginLeft: '-15px', padding: '5px 0' }}
                              className={classes.header}
                              dangerouslySetInnerHTML={{ __html: this.state.quizData[this.state.activeStep].a[idx] }}
                            />
                          </Grid>
                        ) : (
                          <FormControlLabel
                            value={aItem}
                            control={<Radio />}
                            label={this.state.quizData[this.state.activeStep].a[idx]}
                            key={idx}
                            style={{ padding: '5px 0' }}
                          />
                        )}
                      </div>
                    );
                  })}
                </RadioGroup>
              </Paper>

              {this.state.qCount > 0 ? (
                <Grid container justifyContent={this.state.matches ? 'center' : 'flex-start'} xs={12} md={4}>
                  <MobileStepper
                    steps={this.state.qCount}
                    position="static"
                    variant="text"
                    activeStep={this.state.activeStep}
                    nextButton={
                      <Button
                        variant="outlined"
                        color={'primary'}
                        size={this.state.matches ? 'small' : 'medium'}
                        onClick={this.handleNext}
                        style={{ color: '#025a3c', fontWeight: 'bold' }}
                      >
                        {this.state.activeStep === this.state.qCount - 1 ? 'Finish' : 'Next'}
                      </Button>
                    }
                    backButton={
                      <Button size={this.state.matches ? 'small' : 'medium'} onClick={this.handlePrev} variant="outlined">
                        {/*{theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}*/}
                        <b> Back</b>
                      </Button>
                    }
                    style={{ width: '100%' }}
                  />
                </Grid>
              ) : (
                ''
              )}
            </div>
          </DialogContent>

          <DialogActions>
            <Grid container justifyContent="center" direction="column" alignItems="center">
              <Tooltip title="! You cannot edit your answer after clicking Submit !" placement="right">
                <Button
                  autoFocus
                  onClick={this.onSubmit}
                  color="primary"
                  variant={'contained'}
                  size={'large'}
                  fullWidth={false}
                  disabled={!this.state.quizAnswer || Object.keys(this.state.quizAnswer).length !== this.state.qCount}
                >
                  Submit
                  {/* 제출하기 */}
                </Button>
              </Tooltip>
              {/* <div style={{ marginTop: '10px' }}>* 해당 세션의 퀴즈를 모두 풀이하시면 제출하기 버튼이 활성화 됩니다. </div> */}
              <Typography style={{ marginTop: '10px', fontSize: 'large' }}>
                * After completing all the quizzes, the Submit button will be activated.
              </Typography>
              {/* <div style={{ color: 'red' }}>* 제출하기를 누른 이후에는 답을 수정할 수 없습니다.</div> */}
              <Typography style={{ color: 'red', fontSize: 'large' }}>
                * You cannot edit your answer after clicking&nbsp;
                <u>
                  <b>SUBMIT</b>
                </u>
                .
              </Typography>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.confirmOpen}
          onClose={this.handleClose}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Confirm'}</DialogTitle>
          <DialogContent>
            {this.state.confirmSubmit ? (
              <Typography>
                {/* Quiz풀이를 제출하시겠습니까? <br /> 제출하기를 누른 이후에는 답을 수정할 수 없습니다. */}
                Submitting a Quiz answer? <br /> You cannot edit your answer after clicking Submit.
              </Typography>
            ) : (
              <Typography>
                {/* Quiz 풀이를 제출하지 않았습니다. <br /> 창을 닫으시겠습니까? */}
                You have not submitted your Quiz answer. <br /> Are you sure you want to close the window?
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Grid container justifyContent="center">
              <Button onClick={() => this.handleClose('Y')} color="primary" variant="outlined">
                confirm
              </Button>
              <Button onClick={() => this.handleClose('N')} color="error" variant="outlined" autoFocus>
                cancel
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(QuizDialog);
